import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { genderOptions } from '../../../../constants/app.constants';
import { RequestStateEnum } from '../../../../enums/app.enum';
import { UserGenderEnum } from '../../../../enums/user.enums';
import { ModalService } from '../../../../services/modal.service';
import { UserStore } from '../../../../stores/user.store';
import { ButtonComponent } from '../../../atoms/button/button.component';
import { InputComponent } from '../../../atoms/input/input.component';
import { ModalHeaderComponent } from '../../../molecules/modal/modal-header/modal-header.component';
import { RadioGroupWithLabelComponent } from '../../../molecules/radio-group-with-label/radio-group-with-label.component';

@Component({
  selector: 'app-modal-change-user',
  imports: [
    ModalHeaderComponent,
    InputComponent,
    RadioGroupWithLabelComponent,
    ButtonComponent,
    MatRadioModule,
  ],
  templateUrl: './modal-change-user.component.html',
  styleUrl: './modal-change-user.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalChangeUserComponent {
  protected readonly GenderEnum = UserGenderEnum;

  private readonly userStore = inject(UserStore);
  private readonly modalService = inject(ModalService);

  readonly genderOptions = genderOptions;
  readonly user = this.userStore.user;
  readonly isLoading = computed(() => this.userStore.requestState() === RequestStateEnum.PENDING);

  form = new FormGroup({
    firstname: new FormControl<string | null>(null, Validators.required),
    lastname: new FormControl<string | null>(null, Validators.required),
    gender: new FormControl<UserGenderEnum | null>(null, Validators.required),
  });

  readonly formEffect = effect(() => this.setForm());

  private setForm(): void {
    const user = this.user();
    if (user) {
      this.form.controls.firstname.setValue(user.firstname);
      this.form.controls.lastname.setValue(user.lastname);
      this.form.controls.gender.setValue(user.gender);
    }
    this.form.markAsPristine();
    this.form.markAsUntouched();
  }

  public updateUser(): void {
    this.userStore
      .updateUser(
        this.form.controls.firstname.value!,
        this.form.controls.lastname.value!,
        this.form.controls.gender.value!
      )
      .subscribe({
        next: () => {
          this.userStore.updateState();
          this.modalService.close();
        },
      });
  }

  public close(): void {
    this.modalService.close();
  }
}
